import setting from '../../../config.json';
export const PieVisualConfiguration = {
    chart: {
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                } // Use toLocaleString() to add commas
            }
        },
        style: {
            fontFamily: 'Lato-Regular'
        }
    },
    legend: {
        show: true,
        fontFamily: 'Lato-Regular'
    },
    dataLabels: {
        enabled: true,
        dropShadow: {
            enabled: false,
        },
        style: {
            colors: ['#000000'],
            fontSize: '0.875rem',
            // fontWeight: 'normal',
            fontFamily: 'Lato-Regular'
        },
    },
    plotOptions: {
        pie: {
            donut: {
                size: '40%',
            },
            expandOnClick: false,
        },
    },
    animations: {
        enabled: true, // Enable animations
        easing: 'easeinout', // Specify easing function
        speed: 200, // Set animation duration in milliseconds
    }
};

export const VerticalBarVisualConfiguration = {
    chart: {
        type: 'bar',
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            }
        },
        style: {
            fontFamily: 'Lato-Regular',
        }
    },
    xaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        // tickAmount: 6,
        axisBorder: {
            show: false,
            color: '#000',
        },
        axisTicks: {
            show: true,
            color: '#000'
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        },
        tickPlacement: true
    },
    yaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        // tickAmount: 4,
        axisBorder: {
            show: true,
            color: '#000',
        },
        axisTicks: {
            show: true,
            color: '#000',
        },
        labels: {
            formatter: function (value) {
                return value.toLocaleString();
            },
            style: {
                fontFamily: 'Lato-Regular'
            }
        },
        tickPlacement: true,
    },
    grid: {
        show: true,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        },
    },
    legend: {
        markers: {
            radius: 0,
            width: 30
        },
        fontFamily: 'Lato-Regular',
    },
    dataLabels: {
        enabled: false,
        dropShadow: {
            enabled: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '90%',
        },
    },
    stroke: {
        colors: ["transparent"],
        width: 3
    }
};

export const LineVisualConfiguration = {
    chart: {
        type: 'line',
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    if (value !== undefined && value !== null) {
                        return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            }
        },
        style: {
            fontFamily: 'Lato-Regular'
        }
    },
    markers: {
        strokeWidth: 2,
        discrete: {
            fillColor: '#fff',
            size: 3
        }
    },
    xaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular'
            }
        },
        axisBorder: {
            show: true,
            color: '#000',
        },
        axisTicks: {
            show: true,
            color: '#000',
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        }
    },
    yaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular'
            }
        },
        // tickAmount: 4,
        axisBorder: {
            show: true,
            color: '#000',
            strokeWidth: 2
        },
        axisTicks: {
            show: true,
            color: '#000',
        },
        labels: {
            formatter: function (value) {
                return value.toLocaleString();
            },
            style: {
                fontFamily: 'Lato-Regular'
            }
        }
    },
    grid: {
        show: false,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        },
    },
    stroke: {
        width: 2
    },
    legend: {
        markers: {
            radius: 0,
            width: 30
        },
        fontFamily: 'Lato-Regular'
    }
};

export const HorizontalBarVisualConfiguration = {
    chart: {
        type: 'bar',
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            },
        },
        x: {
            formatter: function (value) {
                return value.toUpperCase();
            },
        },
    },
    xaxis: {
        show: false,
        title: {
            show: false,
        },
        labels: {
            show: false
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false
        }
    },
    yaxis: {
        show: false,
        title: {
            show: false,
        },
        labels: {
            show: false
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false
        },
    },
    grid: {
        show: false,
    },
    legend: {
        show: false
    },
    dataLabels: {
        enabled: false,
        dropShadow: {
            enabled: false,
        },
        textAnchor: 'end',
        distributed: true,
        offsetX: 0,
        offsetY: 0,
        style: {
            colors: ['#000'], // Set color of the labels
            fontWeight: 'normal',
            fontSize: 15,
        },

    },
    plotOptions: {
        bar: {
            horizontal: true,
            columnWidth: '100%',
            barHeight: '85%', // Adjust barHeight to move bars closer to the left edge    
        },
    },
    stroke: {
        colors: [''],
        width: ''
    }
};

export const Bar2VisualConfiguration = {
    chart: {
        type: 'bar',
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            },
        },
        x: {
            formatter: function (value) {
                return value.toUpperCase();
            },
        },
    },
    xaxis: {
        show: false,
        title: {
            show: false,
        },
        labels: {
            show: false
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false
        }
    },
    yaxis: {
        show: false,
        title: {
            show: false,
        },
        labels: {
            show: false
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false
        },
    },
    grid: {
        show: false,
    },
    legend: {
        show: false
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
            colors: ['#000'], // Set color of the labels
            fontFamily: 'Lato-Light',
            fontSize: 14
        },
        offsetX: 5, // Moves label inside the bar for padding
        offsetY: 0,
        dropShadow: {
            enabled: false
        }
    },
    plotOptions: {
        bar: {
            barHeight: '90%',
            distributed: false,
            horizontal: true,
            dataLabels: {
                position: 'bottom'
            }
        }
    },
    stroke: {
        width: 1,
        colors: ['#fff']
    },
};

export const ComboVisualConfiguration = {
    chart: {
        width: '100%',
        height: '100%'
    },
    tooltip: {
        style: {
            fontFamily: 'Lato-Regular',
        }
    },
    xaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        axisBorder: {
            show: false,
            color: '#000',
        },
        axisTicks: {
            show: true,
            color: '#000'
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        },
        tickPlacement: true
    },
    yaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        // tickAmount: 4,
        axisBorder: {
            show: true,
            color: '#000',
        },
        axisTicks: {
            show: true,
            color: '#000',
        },
        labels: {
            formatter: function (value) {
                return value.toLocaleString();
            },
            style: {
                fontFamily: 'Lato-Regular'
            }
        },
        tickPlacement: true
    },
    grid: {
        show: true,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        },
    },
    legend: {
        markers: {
            radius: 0,
            width: 30
        },
        fontFamily: 'Lato-Regular',
    },
    dataLabels: {
        enabled: false,
        dropShadow: {
            enabled: false,
        },
    },
    plotOptions: {
        bar: {
            columnWidth: '90%',
            fill: {
                opacity: 1 // Set opacity to 100%
            }
        },
    },
    stroke: {
        colors: ["transparent"],
        width: 3
    }
};

export const HorizontalStackedBarVisualConfiguration = {
    chart: {
        type: 'bar',
        width: '100%',
        height: '100%',
        stacked: true
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            }
        },
        style: {
            fontFamily: 'Lato-Regular',
        }
    },
    xaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: true,
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        },
        tickPlacement: true
    },
    yaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular',
            }
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: true,
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            },
            rotate: -45
        },
        tickPlacement: true
    },
    grid: {
        show: true,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        },
    },
    legend: {
        markers: {
            radius: 80,
            height: 10,
            width: 20
        },
        position: 'right',
        offsetY: 40,
        fontFamily: 'Lato-Regular',
    },
    dataLabels: {
        enabled: true,
        style: {
            colors: ['#000000'],
            fontFamily: 'Lato-Regular',
            fontWeight: 'normal',
        },
        dropShadow: {
            enabled: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barWidth: '10%',
            horizontalAlign: 'center'
            // dataLabels: {
            //     total: {
            //         enabled: true,
            //         offsetX: 0,
            //         style: {
            //             fontFamily: 'Lato-Regular',
            //             fontWeight: 'bold',
            //         }
            //     }
            // }
        },
    }
};

export const BubbleVisualConfiguration = {
    chart: {
        type: 'bubble',
        width: '100%',
        height: '100%'
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            }
        },
        style: {
            fontFamily: 'Lato-Regular'
        }
    },
    xaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular'
            }
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        }
    },
    yaxis: {
        title: {
            style: {
                fontWeight: 'normal',
                fontFamily: 'Lato-Regular'
            }
        },
        tickAmount: 4,
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            style: {
                fontFamily: 'Lato-Regular'
            }
        }
    },
    grid: {
        show: true,
        position: 'back',
        xaxis: {
            lines: {
                show: true
            }
        },
        yaxis: {
            lines: {
                show: true
            }
        },
    },
    stroke: {
        width: 2
    },
    legend: {
        markers: {
            radius: 50,
        },
        fontFamily: 'Lato-Regular'
    },
    dataLabels: {
        enabled: false,
        dropShadow: {
            enabled: false,
        },
    },
};

export const TreeMapVisualConfiguration = {
    chart: {
        height: '100%',
        width: '100%',
        type: "treemap"
    },
    dataLabels: {
        enabled: true,
        style: {
            colors: ['#000000'],
            fontFamily: 'Lato-Regular',
            fontWeight: 'normal',
        },
    },
    tooltip: {
        y: {
            formatter: function (value) {
                if (value !== undefined && value !== null) {
                    return value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                } else {
                    return '';
                }
            }
        },
        style: {
            fontFamily: 'Lato-Regular'
        }
    },
    plotOptions: {
        treemap: {
            enableShades: false,
            distributed: true,
        }
    }
};

export const GaugeVisualConfiguration = {
    chart: {
        height: '100%',
        width: '100%',
        type: 'radialBar',
        padding: 0,
        margin: 0,
    },
    plotOptions: {
        radialBar: {
            startAngle: -135,
            endAngle: 135,
            hollow: {
                background: 'transparent',
                fontFamily: 'Lato-Regular',
                style: {
                    fontFamily: 'Lato-Regular',
                },
            },
            track: {
                background: '#e0e0e0', // Track color
                strokeWidth: '100%', // Track width

            },
            dataLabels: {
                showOn: 'always', // Show data labels always
                style: {
                    fontFamily: 'Lato-Regular',
                },
                name: {
                    offsetY: 75,
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    fontFamily: 'Lato-Regular',
                    color: '#888', // Label color
                    show: true,
                },
                value: {
                    offsetY: 40,
                    fontSize: '1.875rem',
                    fontWeight: 'bold',
                    fontFamily: 'Lato-Regular',
                    show: true, // Always show value   
                }
            }
        }
    },
    legend: {
        show: false,
        fontSize: '1rem',
        fontFamily: 'Lato-Regular',
    },
};

export const Gauge2VisualConfiguration = {
    chart: {
        height: '150%',
        width: '100%',
        type: 'radialBar',
        padding: 0,
        margin: 0,
        toolbar: {
            show: true,
            tools: {
                download: true
            }
        },
        offsetY: 0,
        offsetY: 0
    },
    plotOptions: {
        radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: {
                size: "40%",
            },
            track: {
                background: "#E7E7E7",
                strokeWidth: "97%",
                margin: 5,
                dropShadow: {
                    enabled: true,
                    top: 2,
                    left: 0,
                    color: "#444",
                    opacity: 1,
                    blur: 2,
                },
            },
            dataLabels: {
                name: {
                    show: true,
                    fontFamily: 'Lato-Regular'
                },
                value: {
                    offsetY: 0,
                    fontSize: 18,
                    fontFamily: 'Lato-Regular'
                },
            },
        },
    },
    legend: {
        show: true,
        fontFamily: 'Lato-Regular',
    },
};

export const TableConfiguration = {
    customStyle: {
        headCells: {
            style: {
                fontSize: '0.9375rem',
                fontFamily: 'Lato-Bold'
            }
        },
        cells: {
            style: {
                fontSize: '0.875rem'
            }
        },
        rows: {
            style: {
                cursor: 'move',
            }
        }
    },
    highlightOnHover: true,
    pointerOnHover: true,
    striped: true,
    fixedHeader: true,
    responsive: true,
    expandOnRowClicked: false,
    expandableRows: false,
    expandableRowsHideExpander: true,
    pagination: false
};

const TauriVisualChartConfiguration = () => {

}

export default TauriVisualChartConfiguration;